Intl = require 'intl'
{ locales } = require 'db/locale-information'

formatter = null
module.exports = (num, normalRounding) ->
  formatter ?= new Intl.NumberFormat locales[0],
    minimumFractionDigits: 2
    maximumFractionDigits: 2
  if normalRounding
    formatter.format(num)
  else
    # Trello displays prices like 9.999 as $9.99
    formatter.format(Math.floor(num * 100) / 100)



// WEBPACK FOOTER //
// ./app/scripts/lib/format/money.coffee